const initState=[];
const PaymentsRecordReducer = (state = initState, action) => {
    switch(action.type) {
        case 'PaymentsRecordAction': 
        return  action.payload;
        
        default: return state;
    }
}
export default PaymentsRecordReducer;